import AXIOS from "./axios";

export class Address {
  static create(address) {
    address.zip_code = address.zip_code.replace(/[^0-9.]/g, "");
    return AXIOS.post("addresses", { address });
  }
  static update(address) {
    address.zip_code = address.zip_code.replace(/[^0-9.]/g, "");
    return AXIOS.put(`addresses/${address.id}`, { address });
  }
}
